import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  ProtectedResourceScopes,
} from '@azure/msal-angular';
import { BrowserCacheLocation, Configuration, InteractionType } from '@azure/msal-browser';
import { AppEnvironment, AppEnvironmentLabel } from 'src/app/models/app-environment';
import { VERSION } from './version';

const clientId = '65117733-aef0-45a4-90b7-425481b06a2c';

export const sapDevProxyUrl = 'https://sapd42c00.sap.corp.lego.com:22000/sap/opu/odata/sap';
export const sapQaProxyUrl = 'https://sapqx1c00.sap.corp.lego.com:22000/sap/opu/odata/sap';
export const sapZProxyUrl = 'https://sapz42c00.sap.corp.lego.com:22000/sap/opu/odata/sap';

export const mouldLogApi = {
  url: '/proxy/mould-log',
};

export const mouldingProcessApi = {
  url: '/proxy/moulding-process',
};

export const mouldDesignApi = {
  url: '/proxy/mould-design',
};

export const equipmentApi = {
  url: '/equipment',
};

export const toySafetyApi = {
  url: '/proxy/toy-safety-reports',
};

const msalConfig: Configuration = {
  auth: {
    authority: 'https://login.microsoftonline.com/1d063515-6cad-4195-9486-ea65df456faa/',
    clientId,
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: 'https://localhost:5001/logged-out',
    redirectUri: 'https://localhost:5001',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: new Map<string, Array<ProtectedResourceScopes | string> | null>([
    [
      `${window.location.origin}/bom-header/*`,
      ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default'],
    ],
    [
      `${window.location.origin}/bom-item/*`,
      ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default'],
    ],
    [
      `${window.location.origin}/notification/*`,
      ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default'],
    ],
    [
      `${window.location.origin}/notification-activity/*`,
      ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default'],
    ],
    [
      `${window.location.origin}/material-data/*`,
      ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default'],
    ],
    [
      `${window.location.origin}/project/*`,
      ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default'],
    ],
    [
      `${window.location.origin}/equipment/*`,
      ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default'],
    ],
    [`${window.location.origin}/api/*`, ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default']],
    [`${window.location.origin}/proxy/*`, ['api://3b251d90-5c86-429e-bcfb-3febde3fd511/.default']],
  ]),
};

const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  loginFailedRoute: '/error/login-failed',
};

export const environment = {
  designImageUrl: 'https://dkawww-pic.corp.lego.com/any/256x256',
  environmentName: AppEnvironment.LOCAL,
  environmentLabel: AppEnvironmentLabel.LOCAL,
  legoRestApiUrl: `https://dkatcpr-t1.corp.lego.com/LEGORESTAPI/rest/item/Z`,
  mouldLogApi,
  mouldingProcessApi,
  mouldDesignApi,
  equipmentApi,
  toySafetyApi,
  msalConfig,
  msalGuardConfig,
  msalInterceptorConfig,
  production: false,
  sapUrl: sapDevProxyUrl,
  toySafetyReportTool: new URL('https://toysafety.productcompliance.thelegogroup.com/'),
  sharePointEHDDriveId: 'b!UJd6tluSf0Grk1BaG0P8C4it15diQlpPn05Lw0AejyaitDnYGzHESqgAY_vvmr3f',
  sharePointEHDSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/EHD%20Test/Forms/AllItems.aspx'
  ),
  sharePointERADriveId: 'b!UJd6tluSf0Grk1BaG0P8C4it15diQlpPn05Lw0AejyYvux3FuszORrCfwyGsxLQG',
  sharePointERASiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/ERA%20Test/Forms/AllItems.aspx'
  ),
  sharePointMDTDriveId: 'b!UJd6tluSf0Grk1BaG0P8C4it15diQlpPn05Lw0AejybQq8875yd0QZf7ENp_q1Mh',
  sharePointMDTSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/MDT%20Test/Forms/AllItems.aspx'
  ),
  sharePointPHDDriveId: 'b!UJd6tluSf0Grk1BaG0P8C4it15diQlpPn05Lw0AejyaHjJhTZNcARoFxc9OMUnhA',
  sharePointPHDSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/PHD%20Test/Forms/AllItems.aspx'
  ),
  sharePointSiriusEHDDriveId: 'b!UJd6tluSf0Grk1BaG0P8C4it15diQlpPn05Lw0AejybMp_6c9kCHRp2YV6kOQ0x_',
  sharePointSiriusEHDSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/Sirius%20EHD%20Test/Forms/AllItems.aspx'
  ),
  sharePointTRDriveId: 'b!UJd6tluSf0Grk1BaG0P8C4it15diQlpPn05Lw0AejybpD_V8Wjw3Q5XkpR4z-m4P',
  sharePointTRSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/TR%20Test/Forms/AllItems.aspx'
  ),
  sharePointTSRSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/TSR%20Test/Forms/AllItems.aspx'
  ),
  sharePointVisitationDriveId: 'b!UJd6tluSf0Grk1BaG0P8C4it15diQlpPn05Lw0AejyZoMxjL8FddSZKL3wmntAWb',
  sharePointVisitationSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/EMMETtestsite/Visitation%20Test/Forms/AllItems.aspx'
  ),
  teamcenter: 'https://tcsoa.tcplat-bll.prod.novus.internal.lego/workflow/v1/qa',
  version: VERSION.hash,
  usersnapSpaceApiKey: '049a85a4-51fa-4725-a59c-3243664f49b4',
  usersnapProjectApiKey: 'ff014d7d-cf66-40c1-abb8-abefceef18cb',
  usersnapProjectApiEventName: 'emmet',
  optimizelySdkKey: 'Y8Nmmg4rEWVjdutZ67p5X',
};
